import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export default function Privacy() {
  return (
    <div className="bg-cream grain pt-32 pb-24">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60">— Informativa GDPR</p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal>
              <h1 className="font-heading text-5xl md:text-7xl tracking-tighter leading-[0.9] mb-4">
                Privacy<br />
                <span className="italic text-peach">Policy.</span>
              </h1>
              <p className="text-xs uppercase tracking-[0.3em] text-ink/50">
                Ai sensi dell'art. 13 Reg. UE 2016/679 — GDPR
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-20 md:mt-24 border-t border-line pt-12 md:pt-16">
        <div className="grid grid-cols-12 gap-6 md:gap-16">
          <aside className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-ink/60 mb-3">— Indice</p>
            <ul className="space-y-2 text-sm text-ink/70">
              <li><a href="#titolare" className="editorial-link">Titolare</a></li>
              <li><a href="#dati" className="editorial-link">Dati raccolti</a></li>
              <li><a href="#finalita" className="editorial-link">Finalità</a></li>
              <li><a href="#conservazione" className="editorial-link">Conservazione</a></li>
              <li><a href="#terzi" className="editorial-link">Comunicazione a terzi</a></li>
              <li><a href="#diritti" className="editorial-link">Diritti</a></li>
              <li><a href="#reclami" className="editorial-link">Reclami</a></li>
            </ul>
          </aside>

          <article className="col-span-12 md:col-span-9 max-w-3xl space-y-12 text-ink/80 leading-relaxed text-base md:text-lg">
            <section id="titolare" className="scroll-mt-28">
              <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-ink mb-3">Titolare del trattamento</h2>
              <p>
                Giovanni Gabban — <a href="mailto:giovanni.gabban@gmail.com" className="editorial-link text-peach">giovanni.gabban@gmail.com</a>
              </p>
            </section>

            <section id="dati" className="scroll-mt-28">
              <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-ink mb-3">Dati raccolti</h2>
              <p>
                Tramite il modulo di contatto vengono raccolti: nome, indirizzo email, numero di telefono (facoltativo), testo del messaggio.
              </p>
            </section>

            <section id="finalita" className="scroll-mt-28">
              <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-ink mb-3">Finalità e base giuridica</h2>
              <p>
                I dati sono trattati esclusivamente per rispondere alle richieste di contatto. La base giuridica è il consenso dell'interessato (art. 6, par. 1, lett. a GDPR).
              </p>
            </section>

            <section id="conservazione" className="scroll-mt-28">
              <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-ink mb-3">Conservazione</h2>
              <p>
                I dati vengono conservati per il tempo strettamente necessario a evadere la richiesta e comunque non oltre 12 mesi dalla ricezione.
              </p>
            </section>

            <section id="terzi" className="scroll-mt-28">
              <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-ink mb-3">Comunicazione a terzi</h2>
              <p>
                I dati non vengono ceduti, venduti o comunicati a terzi, salvo fornitori tecnici strettamente necessari alla gestione del sito (es. Emergent Agent Inc., responsabile del trattamento).
              </p>
            </section>

            <section id="diritti" className="scroll-mt-28">
              <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-ink mb-3">Diritti dell'interessato</h2>
              <p>
                Hai il diritto di accedere ai tuoi dati, rettificarli, cancellarli, limitarne il trattamento o opporti al loro uso. Puoi esercitare questi diritti scrivendo a <a href="mailto:giovanni.gabban@gmail.com" className="editorial-link text-peach">giovanni.gabban@gmail.com</a>.
              </p>
            </section>

            <section id="reclami" className="scroll-mt-28">
              <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-ink mb-3">Reclami</h2>
              <p>
                Hai il diritto di proporre reclamo al Garante per la protezione dei dati personali — <a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer" className="editorial-link text-peach">www.garanteprivacy.it</a>.
              </p>
            </section>

            <div className="border-t border-line pt-8 text-sm text-ink/50">
              Ultimo aggiornamento: 2026 · <Link to="/" className="editorial-link">Torna alla home</Link>
            </div>
          </article>
        </div>
      </section>
    </div>
  );
}
